import { ScrollBar } from "./ScrollBar";

/**
 * @en The vertical scrollbar (VScrollBar) is used to scroll and view all content in the vertical direction when there is too much data to fit in the display area.
 * @zh 垂直滚动条（VScrollBar）用于垂直方向因数据过多而超出显示区域时滚动查看全部内容。
 */
export class VScrollBar extends ScrollBar {

}